export default ({ store, route }) => {
  if (store.getters['popup/popupActive']) {
    store.commit('popup/closePopup');
  }

  if (route.name && route.name.indexOf('registration-') === -1 && store.state.flow.percent !== 0) {
    store.commit('flow/setPercent', '');
  }
};
